module.exports = __webpack_public_path__ + "static/IPE_zoom-724da86e98461bfe57a47c0f9b203826.png";